module.exports = __webpack_public_path__ + "assets/img/introduction_culture_img_3.4cf0c955.png";